import config, {weather_base_url} from "../config"
const baseUrl = config.weather_base_url + "weather_item_city30/"
export default {
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    listByPId: {
        url: baseUrl + "listByPId",
        type: "get",
    },
    listByPIdWithLimit: {
        url: baseUrl + "listByPIdWithLimit",
        type: "get",
    }
}
